import { useMemo } from 'react';
import type { ProjectStatusInput } from '@frameio/graphql-client/generated';
import { useWorkspacesProjectFilter } from '../components/WorkspaceOverflowMenu/WorkspacesProjectFilterContextProvider';

export const useWorkspacesProjectFilterAsInput = (): ProjectStatusInput[] => {
  const workspacesProjectFilter = useWorkspacesProjectFilter();

  return useMemo(() => {
    if (workspacesProjectFilter === 'ALL') return ['ACTIVE', 'INACTIVE'];
    if (workspacesProjectFilter) return [workspacesProjectFilter];
    return [];
  }, [workspacesProjectFilter]);
};
